/**
 * Collection Sub-Navigation Toggle
 * Handles "+ More" / "- Show Less" functionality
 */

document.addEventListener('DOMContentLoaded', () => {
  const nav = document.querySelector('[data-sub-nav]');
  if (!nav) return;

  const toggleBtn = nav.querySelector('[data-sub-nav-toggle]');
  if (!toggleBtn) return;

  const hiddenItems = nav.querySelectorAll('.collection-sub-nav__item--hidden');
  const moreText = toggleBtn.querySelector('[data-toggle-text-more]');
  const lessText = toggleBtn.querySelector('[data-toggle-text-less]');

  toggleBtn.addEventListener('click', () => {
    const isExpanded = toggleBtn.getAttribute('aria-expanded') === 'true';

    if (isExpanded) {
      // Collapse
      hiddenItems.forEach(item => {
        item.classList.add('collection-sub-nav__item--hidden');
      });
      toggleBtn.setAttribute('aria-expanded', 'false');
      moreText.style.display = '';
      lessText.style.display = 'none';
    } else {
      // Expand
      hiddenItems.forEach(item => {
        item.classList.remove('collection-sub-nav__item--hidden');
      });
      toggleBtn.setAttribute('aria-expanded', 'true');
      moreText.style.display = 'none';
      lessText.style.display = '';
    }
  });
});
